var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { breadcrumDTO } from "../../../dataBase/layout";
import LocalStorageService from "../../../services/localStorage";
import * as catalogConst from "../../../const/catalog";
import { plan } from "../../../store/plan/actions";
import { getHeader } from "../../../resources/headers";
import { handleUnauthorized } from "../../../resources/fetchRequest";
import { deleteEntityClearData } from "../../../store/delete/actions";
import { cancelQuoteClearData } from "../../../store/cancelQuote/actions";
import { policyCancelClearData } from "../../../store/policy/actions";
import { getCatalogStatusQuote, getCatalogsTypeClearData, } from "../../../store/catalog/actions";
import { sponsor, sponsorClearData } from "../../../store/sponsor/actions";
import { insuranceClearData } from "../../../store/insurance/actions";
import { Branches } from "../../../store/branches/actions";
import { useTranslation } from "react-i18next";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import { Steps } from "../../../enum/steps";
import { useAuditLogs } from "../../confirmationForm/hooks/useAuditLogs";
import { quoteAll, quoteAllClearData, } from "../../../store/generateQuote/actions";
import { GetCatalogsType } from "../../../fnx/catalog/getCatalogsType";
import { GetProjectOne } from "../../../fnx/project/projectOne";
import { useGetWokFlow } from "../../../fnx/workFlow/getWorkFlow";
import { buildAndSaveWorkflowSteps } from "ah_utility/workflow";
import { getWorkFlowClearData } from "../../../store/workFlow/actions";
import { projectOneClearData } from "../../../store/project/actions";
import { getQuoteList, getQuotePagingInfo, } from "../../../utils/normalizeQuoteResponse";
import useInsurancePoliciesSelectors from "./useInsurancePoliciesSelectors";
import useInsurancePoliciesUI from "./useInsurancePoliciesUI";
import useInsurancePoliciesActions from "./useInsurancePoliciesActions";
import { useInsurancePoliciesErrorHandling } from "./useInsurancePoliciesErrorHandling";
import { getDefaultCheckedStatusItems, getDefaultProjectIds, isApapAutoSubdomain, } from "./insurancePoliciesSummaryRules";
import { INSURANCE_POLICIES_PAGE_TITLE, INSURANCE_POLICIES_REPORT_FIELDS, INSURANCE_POLICIES_REPORT_LABEL_FIELDS, INSURANCE_POLICIES_STORAGE_KEY_LOGIN, INSURANCE_POLICIES_STORAGE_KEY_STEPS, PENDIENTE_ID_PARAM, } from "../constants/insurancePoliciesSummary.constants";
var lsLogin = new LocalStorageService(INSURANCE_POLICIES_STORAGE_KEY_LOGIN);
var localStorageService = new LocalStorageService(INSURANCE_POLICIES_STORAGE_KEY_STEPS);
export var useInsurancePoliciesSummary = function () {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _a = React.useState(false), openModalUpdate = _a[0], setOpenModalUpdate = _a[1];
    var _b = React.useState(""), selectedQuoteStatus = _b[0], setSelectedQuoteStatus = _b[1];
    var navigate = useNavigate();
    var id = useParams().id;
    var _c = React.useState(true), enable = _c[0], setEnable = _c[1];
    var _d = React.useState(1), page = _d[0], setPage = _d[1];
    var _e = React.useState(null), historialQuoteId = _e[0], setHistorialQuoteId = _e[1];
    var _f = React.useState(100), limit = _f[0], setLimit = _f[1];
    var _g = useState([]), rows = _g[0], setRows = _g[1];
    var _h = React.useState([]), breadCrumbs = _h[0], setBreadCrumbs = _h[1];
    var _j = React.useState(false), openModal = _j[0], setOpenModal = _j[1];
    var _k = React.useState(false), openModalHistorial = _k[0], setOpenModalHistorial = _k[1];
    var _l = React.useState("---"), modalTitle = _l[0], setModalTitle = _l[1];
    var _m = React.useState(false), openModalConfirm = _m[0], setOpenModalConfirm = _m[1];
    var _o = React.useState([]), reasonCancellation = _o[0], setReasonCancellation = _o[1];
    var _p = React.useState(""), policyId = _p[0], setPolicyId = _p[1];
    var _q = React.useState(true), type = _q[0], setType = _q[1];
    var _r = React.useState({}), row = _r[0], setRow = _r[1];
    var _s = useState([]), statusOptions = _s[0], setStatusOptions = _s[1];
    var _t = useState([]), insuranceOptions = _t[0], setInsuranceOptions = _t[1];
    var _u = useState([]), branchesOptions = _u[0], setBranchesOptions = _u[1];
    var _v = React.useState(""), idCatalogStatusQuote = _v[0], setIdCatalogStatusQuote = _v[1];
    var _w = useState(false), trigger = _w[0], setTrigger = _w[1];
    var _x = useState(false), triggerCatalogs = _x[0], setTriggerCatalog = _x[1];
    var _y = useState(false), productFiltersReady = _y[0], setProductFiltersReady = _y[1];
    var _z = React.useState(""), dateStart = _z[0], setDateStart = _z[1];
    var _0 = React.useState(""), dateEnd = _0[0], setDateEnd = _0[1];
    var _1 = React.useState(false), isLoadin = _1[0], setIsLoading = _1[1];
    var _2 = React.useState(1000), totalRecords = _2[0], setTotalRecords = _2[1];
    var _3 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _3[0], setSeeToast = _3[1];
    var _4 = useState(""), nameSearch = _4[0], setNameSearch = _4[1];
    var _5 = React.useState(""), selectedBranches = _5[0], setSelectedBranches = _5[1];
    var _6 = React.useState(""), selectedProjects = _6[0], setSelectedProjects = _6[1];
    var _7 = React.useState(undefined), selectedIsLegacy = _7[0], setSelectedIsLegacy = _7[1];
    var _8 = React.useState(false), triggerWorkflow = _8[0], setTriggerWorkflow = _8[1];
    var _9 = React.useState(""), workflowId = _9[0], setWorkflowId = _9[1];
    var skipPageLimitEffect = React.useRef(true);
    var skipNameSearchEffect = React.useRef(true);
    var appliedDefaultStatusRef = React.useRef(false);
    var isFirstFilterChangeRef = React.useRef(true);
    var buildQuoteAllParams = React.useCallback(function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        var params = {
            clientId: clientId,
            enable: enable,
            page: page,
            limit: limit,
        };
        var hasOwn = Object.prototype.hasOwnProperty;
        var statuses = hasOwn.call(overrides, "statuses")
            ? overrides.statuses
            : idCatalogStatusQuote;
        if (statuses) {
            params.statuses = statuses;
        }
        var start = hasOwn.call(overrides, "creationDateStart")
            ? overrides.creationDateStart
            : dateStart;
        if (start) {
            params.creationDateStart = start;
        }
        var end = hasOwn.call(overrides, "creationDateEnd")
            ? overrides.creationDateEnd
            : dateEnd;
        if (end) {
            params.creationDateEnd = end;
        }
        var branches = hasOwn.call(overrides, "branches")
            ? overrides.branches
            : selectedBranches;
        if (branches) {
            params.branches = branches;
        }
        var projects = hasOwn.call(overrides, "projectIds")
            ? overrides.projectIds
            : selectedProjects || getDefaultProjectIds();
        if (projects) {
            params.projectIds = projects;
        }
        var isLegacyValue = hasOwn.call(overrides, "isLegacy")
            ? overrides.isLegacy
            : selectedIsLegacy;
        if (isLegacyValue !== undefined) {
            params.isLegacy = isLegacyValue;
        }
        var searchValue = hasOwn.call(overrides, "search")
            ? overrides.search
            : nameSearch;
        if (searchValue || searchValue === "") {
            params.search = searchValue;
        }
        if (hasOwn.call(overrides, "page")) {
            params.page = overrides.page;
        }
        if (hasOwn.call(overrides, "limit")) {
            params.limit = overrides.limit;
        }
        return params;
    }, [
        clientId,
        enable,
        page,
        limit,
        idCatalogStatusQuote,
        dateStart,
        dateEnd,
        selectedBranches,
        selectedProjects,
        selectedIsLegacy,
        nameSearch,
    ]);
    var fetchQuotes = React.useCallback(function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        dispatch(quoteAll(buildQuoteAllParams(overrides)));
    }, [dispatch, buildQuoteAllParams]);
    var fields = INSURANCE_POLICIES_REPORT_FIELDS;
    var labelFields = INSURANCE_POLICIES_REPORT_LABEL_FIELDS;
    var _10 = useInsurancePoliciesSelectors(clientId, trigger), responseCancelPolicy = _10.responseCancelPolicy, loadingCancelPolicy = _10.loadingCancelPolicy, errorCancelPolicy = _10.errorCancelPolicy, errorDeleteEntity = _10.errorDeleteEntity, responseCancelQuote = _10.responseCancelQuote, loadingCancelQuote = _10.loadingCancelQuote, responsePlan = _10.responsePlan, errorPlan = _10.errorPlan, responseProject = _10.responseProject, errorProject = _10.errorProject, responseGetCatalogStatusQuote = _10.responseGetCatalogStatusQuote, errorGetCatalogStatusQuote = _10.errorGetCatalogStatusQuote, responseAllQuote = _10.responseAllQuote, errorAllQuote = _10.errorAllQuote, loadingAllQuote = _10.loadingAllQuote, responseBranches = _10.responseBranches, errorBranches = _10.errorBranches, responseSponsor = _10.responseSponsor, errorSponsor = _10.errorSponsor, responseInsurance = _10.responseInsurance;
    var _11 = useInsurancePoliciesUI(setOpenModal, setOpenModalConfirm, setOpenModalHistorial), handleOpenModal = _11.handleOpenModal, handleCloseModal = _11.handleCloseModal, handleOpenModalConfirm = _11.handleOpenModalConfirm, handleCloseModalConfirm = _11.handleCloseModalConfirm, handleConfirm = _11.handleConfirm;
    var _12 = useAuditLogs({
        enable: !!historialQuoteId,
        page: 0,
        size: 100,
        orderDir: "ASC",
        quoteId: historialQuoteId,
        setSeeToast: setSeeToast,
        t: t,
    }), historialLogEntries = _12.logEntries, loadingGetAuditLogs = _12.loadingGetAuditLogs;
    var _13 = GetCatalogsType(triggerCatalogs, enable, page, limit, catalogConst.CATALOG_REASON_CANCELLATION), responseGetCatalogsType = _13.responseGetCatalogsType, loadingGetCatalogsType = _13.loadingGetCatalogsType, errorGetCatalogsType = _13.errorGetCatalogsType;
    useInsurancePoliciesErrorHandling({
        errorCancelPolicy: errorCancelPolicy,
        errorDeleteEntity: errorDeleteEntity,
        errorSponsor: errorSponsor,
        errorPlan: errorPlan,
        errorProject: errorProject,
        errorGetCatalogStatusQuote: errorGetCatalogStatusQuote,
        errorAllQuote: errorAllQuote,
        errorBranches: errorBranches,
        errorGetCatalogsType: errorGetCatalogsType,
        setSeeToast: setSeeToast,
    });
    var activatePolicy = function (policyId) {
        if (!policyId) {
            showToastSuccessMessage("ID de póliza no válido", typeAlert.error, setSeeToast);
            return;
        }
        setOpenModalUpdate(true);
        setPolicyId(policyId);
    };
    var _14 = useInsurancePoliciesActions(setIdCatalogStatusQuote, setDateStart, setDateEnd, clientId, enable, page, limit, nameSearch, setIsLoading, idCatalogStatusQuote, dateStart, dateEnd, fields, labelFields, setSeeToast, setBranchesOptions, showToastSuccessMessage, setNameSearch, setSelectedBranches, setSelectedProjects, setSelectedIsLegacy, setPage, fetchQuotes, setInsuranceOptions, setStatusOptions, setRows, responseInsurance, localStorageService, navigate, Steps, setModalTitle, setPolicyId, setType, setOpenModal, setRow, setOpenModalConfirm, type, policyId, activatePolicy, setHistorialQuoteId, setOpenModalHistorial, selectedBranches, selectedProjects), filterStatus = _14.filterStatus, onClickDownload = _14.onClickDownload, getQuoteAll = _14.getQuoteAll, searchFilter = _14.searchFilter, getQuoteStatus = _14.getQuoteStatus, setBranchesOptionsStorybook = _14.setBranchesOptionsStorybook, setInsuranceOptionsStorybook = _14.setInsuranceOptionsStorybook, setStatusOptionsStorybook = _14.setStatusOptionsStorybook, setDataQuoteStorybook = _14.setDataQuoteStorybook, filterData = _14.filterData, handleClickContextMenu = _14.handleClickContextMenu, handleCancelPolicy = _14.handleCancelPolicy, projectId = _14.projectId, triggerProject = _14.triggerProject, dataRow = _14.dataRow;
    var handleFilterChange = function (item) {
        var _a, _b, _c;
        var isEmptyFilterChange = !((_a = item === null || item === void 0 ? void 0 : item.state) === null || _a === void 0 ? void 0 : _a.length) &&
            !((_b = item === null || item === void 0 ? void 0 : item.branchs) === null || _b === void 0 ? void 0 : _b.length) &&
            !((_c = item === null || item === void 0 ? void 0 : item.insurance) === null || _c === void 0 ? void 0 : _c.length);
        if (isFirstFilterChangeRef.current &&
            isEmptyFilterChange &&
            isApapAutoSubdomain()) {
            isFirstFilterChangeRef.current = false;
            return;
        }
        isFirstFilterChangeRef.current = false;
        filterStatus(item);
    };
    var _15 = GetProjectOne(triggerProject, projectId), responseOneProject = _15.responseOneProject, errorOneProject = _15.errorOneProject, loadingOneProject = _15.loadingOneProject;
    var _16 = useGetWokFlow(triggerWorkflow, workflowId, function () { return setTriggerWorkflow(false); }), loadingWorkFlow = _16.loadingWorkFlow, responseWorkFlow = _16.responseWorkFlow, errorWorkflow = _16.errorWorkflow;
    useEffect(function () {
        localStorage.removeItem("WorkFlowId");
        localStorage.removeItem("Quote");
        localStorage.removeItem("steps");
        localStorage.removeItem("summary");
        localStorage.removeItem("afy-variables");
        localStorage.removeItem("afy-action-flags");
        setTriggerCatalog(true);
        if (!responseBranches) {
            dispatch(Branches({
                enable: enable,
                page: page,
                limit: limit,
                clientId: clientId,
            }));
        }
        if (!responsePlan) {
            dispatch(plan({ enable: enable, page: page, limit: 500 }));
        }
        if (!responseGetCatalogStatusQuote) {
            dispatch(getCatalogStatusQuote({ enable: enable, page: page, limit: limit }));
        }
        dispatch(deleteEntityClearData());
        dispatch(sponsorClearData());
        dispatch(insuranceClearData());
        setProductFiltersReady(true);
        return function () {
            dispatch(sponsorClearData());
            dispatch(insuranceClearData());
        };
    }, []);
    useEffect(function () {
        if (!productFiltersReady)
            return;
        dispatch(sponsor({
            enable: enable,
            page: page,
            limit: limit,
            clientId: clientId,
        }));
    }, [productFiltersReady]);
    useEffect(function () {
        var _a;
        if (responseOneProject) {
            var alterWorkflow = (_a = responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.workflows) === null || _a === void 0 ? void 0 : _a.find(function (workflow) { return workflow.page === "alter_flow"; });
            if (!alterWorkflow) {
                showToastSuccessMessage("El producto no tiene un flujo de venta alterno asociado", typeAlert.warning, setSeeToast);
            }
            else {
                setWorkflowId(alterWorkflow.id);
                localStorage.setItem("WorkFlowId", alterWorkflow.id);
                setTriggerWorkflow(true);
            }
            dispatch(projectOneClearData());
        }
    }, [responseOneProject]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (responseWorkFlow && (dataRow === null || dataRow === void 0 ? void 0 : dataRow.id)) {
            var nodes = (_b = (_a = responseWorkFlow.draftDataMap) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.nodes;
            var edges = (_d = (_c = responseWorkFlow.draftDataMap) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.edges;
            buildAndSaveWorkflowSteps(nodes, edges, "steps", true);
            dispatch(getWorkFlowClearData());
            navigate("/confirmationForm/".concat((_e = dataRow === null || dataRow === void 0 ? void 0 : dataRow.id) !== null && _e !== void 0 ? _e : "", "/true/false/").concat((_f = dataRow === null || dataRow === void 0 ? void 0 : dataRow.productId) !== null && _f !== void 0 ? _f : ""));
        }
    }, [responseWorkFlow]);
    useEffect(function () {
        if (responseCancelQuote) {
            showToastSuccessMessage("Cotizacion eliminada correctamente", typeAlert.success, setSeeToast);
            fetchQuotes();
            dispatch(quoteAllClearData());
            dispatch(cancelQuoteClearData());
        }
    }, [responseCancelQuote, fetchQuotes]);
    useEffect(function () {
        if (responseCancelPolicy && responseCancelPolicy.data) {
            showToastSuccessMessage("Póliza cancelada correctamente", typeAlert.success, setSeeToast);
            dispatch(quoteAllClearData());
            fetchQuotes();
            dispatch(policyCancelClearData());
        }
    }, [responseCancelPolicy, fetchQuotes]);
    useEffect(function () {
        if (Array.isArray(responseGetCatalogsType)) {
            var newArray = responseGetCatalogsType.map(function (item) { return ({
                id: item.id,
                value: item.id,
                name: item.description,
            }); });
            setReasonCancellation(newArray);
            dispatch(getCatalogsTypeClearData());
            setTriggerCatalog(false);
        }
    }, [responseGetCatalogsType]);
    useEffect(function () {
        if (!responseAllQuote)
            return;
        var quoteList = getQuoteList(responseAllQuote);
        setDataQuoteStorybook(quoteList);
        var paging = getQuotePagingInfo(responseAllQuote);
        if ((paging === null || paging === void 0 ? void 0 : paging.totalItems) !== undefined) {
            setTotalRecords(paging.totalItems);
        }
    }, [responseAllQuote]);
    useEffect(function () {
        if (Array.isArray(responseGetCatalogStatusQuote)) {
            setStatusOptionsStorybook(responseGetCatalogStatusQuote);
        }
    }, [responseGetCatalogStatusQuote]);
    useEffect(function () {
        if (Array.isArray(responseInsurance)) {
            setInsuranceOptionsStorybook(responseInsurance);
        }
    }, [responseInsurance]);
    useEffect(function () {
        if (Array.isArray(responseBranches)) {
            setBranchesOptionsStorybook(responseBranches);
        }
    }, [responseBranches]);
    useEffect(function () {
        setBreadCrumbs(breadcrumDTO());
    }, [responseSponsor]);
    useEffect(function () {
        if (skipNameSearchEffect.current) {
            skipNameSearchEffect.current = false;
            return;
        }
        if (nameSearch) {
            getQuoteAll();
        }
    }, [nameSearch]);
    useEffect(function () {
        if (skipPageLimitEffect.current) {
            skipPageLimitEffect.current = false;
            return;
        }
        getQuoteAll();
    }, [page, limit]);
    useEffect(function () {
        if (id === PENDIENTE_ID_PARAM) {
            var pendienteStatus = statusOptions.find(function (status) {
                var _a, _b;
                return ((_a = status.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes("pendiente")) ||
                    ((_b = status.value) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes("pendiente"));
            });
            if (pendienteStatus) {
                setIdCatalogStatusQuote(pendienteStatus.id || pendienteStatus.value || "");
                pendienteStatus.active = true;
                getQuoteStatus(pendienteStatus.id);
            }
        }
    }, [id, statusOptions]);
    useEffect(function () {
        if (!isApapAutoSubdomain())
            return;
        if (appliedDefaultStatusRef.current)
            return;
        if (id === PENDIENTE_ID_PARAM)
            return;
        if (!statusOptions.length)
            return;
        appliedDefaultStatusRef.current = true;
        var defaultStatuses = getDefaultCheckedStatusItems(statusOptions);
        filterStatus(defaultStatuses.length > 0 ? { state: defaultStatuses } : {});
    }, [statusOptions, id]);
    var onChangePage = function (page) {
        setPage(page);
    };
    var onChangeRowsPerPage = function (limit) {
        setLimit(limit);
        setPage(1);
    };
    var updatePolicyStatus = function (policyId, catalogStatus) { return __awaiter(void 0, void 0, void 0, function () {
        var apiUrl, requestBody, requestOptions, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiUrl = "".concat(process.env.REACT_APP_HOST_API, "/asg/Api/V1/Policy/").concat(policyId, "/status");
                    requestBody = {
                        data: {
                            catalogStatus: catalogStatus,
                        },
                    };
                    requestOptions = {
                        method: "PATCH",
                        body: JSON.stringify(requestBody),
                        headers: getHeader(),
                    };
                    return [4 /*yield*/, fetch(apiUrl, requestOptions)];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    handleUnauthorized(response.status);
                    return [4 /*yield*/, response.json()];
                case 2: throw _a.sent();
                case 3: return [4 /*yield*/, response.json()];
                case 4: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var onUpdateConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setOpenModalUpdate(false);
                    if (!policyId || !selectedQuoteStatus) {
                        showToastSuccessMessage("Seleccione un estado.", typeAlert.warning, setSeeToast);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updatePolicyStatus(policyId, selectedQuoteStatus)];
                case 2:
                    _a.sent();
                    showToastSuccessMessage("Actualizado correctamente", typeAlert.info, setSeeToast);
                    getQuoteAll();
                    setSelectedQuoteStatus("");
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    showToastSuccessMessage("Error al actualizar", typeAlert.error, setSeeToast);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onUpdateCancel = function () {
        setOpenModalUpdate(false);
        setSelectedQuoteStatus("");
    };
    var handleStatusChange = function (event) {
        setSelectedQuoteStatus(event.target.value);
    };
    return {
        seeToast: seeToast,
        setSeeToast: setSeeToast,
        loading: loadingAllQuote ||
            loadingCancelQuote ||
            loadingCancelPolicy ||
            isLoadin ||
            loadingGetCatalogsType ||
            loadingOneProject ||
            loadingWorkFlow,
        isLoadin: isLoadin,
        breadCrumbs: breadCrumbs,
        title: INSURANCE_POLICIES_PAGE_TITLE,
        rows: rows,
        totalRecords: totalRecords,
        page: page,
        limit: limit,
        onChangePage: onChangePage,
        onChangeRowsPerPage: onChangeRowsPerPage,
        insuranceOptions: insuranceOptions,
        statusOptions: statusOptions,
        branchesOptions: branchesOptions,
        handleClickContextMenu: handleClickContextMenu,
        handleFilterChange: handleFilterChange,
        searchFilter: searchFilter,
        getQuoteAll: getQuoteAll,
        onClickDownload: onClickDownload,
        openModal: openModal,
        modalTitle: modalTitle,
        row: row,
        isPolicy: type,
        handleOpenModal: handleOpenModal,
        handleCloseModal: handleCloseModal,
        handleCancelPolicy: handleCancelPolicy,
        reasonCancellation: reasonCancellation,
        openModalConfirm: openModalConfirm,
        handleOpenModalConfirm: handleOpenModalConfirm,
        handleCloseModalConfirm: handleCloseModalConfirm,
        handleConfirm: handleConfirm,
        openModalHistorial: openModalHistorial,
        historialLogEntries: historialLogEntries,
        loadingGetAuditLogs: loadingGetAuditLogs,
        openModalUpdate: openModalUpdate,
        selectedQuoteStatus: selectedQuoteStatus,
        onUpdateConfirm: onUpdateConfirm,
        onUpdateCancel: onUpdateCancel,
        handleStatusChange: handleStatusChange,
    };
};
export default useInsurancePoliciesSummary;
